import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormControl, ValidationErrors } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { StationService } from 'src/app/services/station.service';
import { EmployeeService } from 'src/app/services/employee.service';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { ReservationService } from 'src/app/services/reservation.service';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
@Component({
  selector: 'app-add-contracts',
  templateUrl: './add-contracts.component.html',
  styleUrls: ['./add-contracts.component.scss']
})
export class AddContractsComponent implements OnInit {
  formTitle :any;
  contractsForm !: FormGroup;
  submitted = false;
  today = moment().format('MM/DD/YYYY');
  contractTypes :any;
  selectedContractType: any;
  public constructor(
    private notifier: NotifierService,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
    private authService: AuthenticationService,
    private router: Router,
    private reservationService: ReservationService,
    private stationService: StationService,
    private employeeService: EmployeeService,
    private authenticationService: AuthenticationService) {
  }

  ngOnInit() {
    this.formTitle = "Add Contracts";
    let st = moment().format('MM/DD/YYYY');
    this.contractsForm = new FormGroup({
      contractID: new FormControl('', Validators.required),
      discount_percent: new FormControl('', Validators.compose([Validators.required])),
      contractType: new FormControl('',Validators.required),
      active: new FormControl(true, Validators.compose([Validators.required])),
      effectsDate: new FormControl(st, Validators.compose([Validators.required])),
      // description : new FormControl('')
    });
    this.getAllContractTypes()
  }
  getAllContractTypes(){
    this.reservationService.getContractTypes().subscribe(res => {
      this.contractTypes = res['result'];
    });
  }
  backToContractServices() {
    // this.location.back();
    this.router.navigateByUrl("home/contracts");
  }
  customValidation(control: FormControl): ValidationErrors | null {
    const value = control.value || '';
    const hasSpaces = value.includes(' ');
    const startsWithSpecialChar = /^[^a-zA-Z0-9]/.test(value); 
    const containsInvalidSpecialChar = /[^a-zA-Z0-9-]/.test(value); 
    if (hasSpaces) {
      return { noSpaces: true };
    }
    if (startsWithSpecialChar) {
      return { noSpecialCharStart: true };
    }
    if (containsInvalidSpecialChar) {
      return { noSpecialChar: true };
    }
    return null; // No errors
  }
  convertToUpperCase(event: any): void {
    const input = event.target;
    input.value = input.value.toUpperCase(); // Convert the value to uppercase
  }
  get f(): any {
    return this.contractsForm.controls;
  }
  validation_messages = {
    'contractID': [
      { type: 'required', message: 'Contract ID is required.' },
   
    ],
    'contractType': [
      { type: 'required', message: 'Contract Type is required.' }
    ],
    'discount_percent': [
      { type: 'required', message: 'Discount(%) is required.' }
    ],
    'active': [
      { type: 'required', message: 'Status is required.' }
    ],
    'effectsDate': [
      { type: 'required', message: 'Effective Date is required.' }
    ]

  }
  get contractscontrols() { return this.contractsForm.controls; }
  onAddContracts(values){
    this.submitted = true;
    this.validateContract();
    this.contractsForm.markAllAsTouched();
    if (this.contractsForm.invalid) {
      return;
    }
    if (! (moment(values.effectsDate).isSameOrAfter(moment(this.today)) ) ){
      this.notifier.notify('warning', 'Effective start date should be today or future date!');
      return false;
    }
    var data = {
      contractId: values.contractID,
      contractType: values.contractType,
      discount_percent: values.discount_percent,
      lcbId: this.authService.getCurrentUserId(),
      active: true,
      effectiveStartDate: moment(values.effectsDate).format('MM/DD/YYYY'),
      // description : values.description
    }

    // this.spinner.show()
    this.reservationService.insertContracts(data).subscribe((res: any) => {
      if (res['status']) {
        this.spinner.hide()
        this.submitted = false
        this.notifier.notify('success', 'Contract Service added successfully');
       // this.initAddContractForm();
        this.router.navigateByUrl("home/contracts");
      }  else {
        this.submitted = false
        this.spinner.hide()
        this.notifier.notify('danger', res['message'])
      }
    }, err => {
      this.notifier.notify('danger', err.message)
      // console.log(err);
    })
    
  }
  validateContract() {
    //console.log("callingg...");
    if (this.contractscontrols.contractID.errors) {
      this.notifier.notify('warning', 'Please enter Contract ID');
      return false;
    }
    if (this.contractscontrols.contractType.errors) {
      this.notifier.notify('warning', 'Please enter Contract Type');
      return false;
    }
    if (this.contractscontrols.discount_percent.errors) {
      this.notifier.notify('warning', 'Please enter Discount');
      return false;
    }
  }
}
